import { useReducedMotion } from 'framer-motion';

interface MarqueeProps {
  items: string[];
  className?: string;
  /** Tailwind `from-*` color for the edge fades (match the section background). */
  fadeFrom?: string;
}

const Marquee = ({ items, className = '', fadeFrom = 'from-slate-950' }: MarqueeProps) => {
  const reduce = useReducedMotion();

  const itemClass = 'text-sm font-semibold uppercase tracking-widest text-slate-400/90';

  if (reduce) {
    return (
      <div className={`flex flex-wrap items-center justify-center gap-x-10 gap-y-3 ${className}`}>
        {items.map((item) => (
          <span key={item} className={itemClass}>
            {item}
          </span>
        ))}
      </div>
    );
  }

  const loop = [...items, ...items];

  return (
    <div className={`group relative overflow-hidden ${className}`}>
      <div
        className={`pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r ${fadeFrom} to-transparent`}
      />
      <div
        className={`pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l ${fadeFrom} to-transparent`}
      />
      <div className="flex w-max animate-marquee items-center gap-x-12 pr-12 group-hover:[animation-play-state:paused]">
        {loop.map((item, i) => (
          <span key={i} className={itemClass} aria-hidden={i >= items.length}>
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
